import { type PropsWithChildren, useLayoutEffect, useRef } from "react";
import { useCurrentLocation } from "../../lib/urls";
import { NavigationTracerContext } from "./context";
import { createTracer, type Tracer } from "./tracer";

export function NavigationTracer({ children }: PropsWithChildren) {
  const path = useCurrentLocation().split(/[?#]/, 1)[0]!;
  const tracerRef = useRef<Tracer>(createTracer());

  useLayoutEffect(() => {
    tracerRef.current.start(path);
  }, [path]);

  return (
    // oxlint-disable-next-line react/react-compiler -- blocks React Compiler; remove when fixed
    <NavigationTracerContext.Provider value={tracerRef.current}>
      {children}
    </NavigationTracerContext.Provider>
  );
}
